import React, { HTMLAttributes } from 'react';

import useSignLease from '../../../../../../context';
import classes from './index.module.scss';
import Typography from '../../../../../../../../../components/generics/texts/Typography';

const PropertyHeader = ({ className }: HTMLAttributes<HTMLDivElement>) => {
  const { data } = useSignLease();

  const { address, photos, onMarketLease } = data!.units[0];
  const addressParts = address.split(', ');
  const addressLine = addressParts[0];
  const cityLine = `${addressParts[1]} ${addressParts[2]}`;

  return (
    <div className={classes.propertyDetails}>
      {photos?.length > 0 && (
        <img
          src={photos[0].uri}
          alt="Property"
          className={classes.image}
        />
      )}
      <div>
        <Typography className={classes.propertyName}>{addressLine}</Typography>
        <Typography className={classes.propertyLocation}>{cityLine}</Typography>
      </div>
    </div>
  );
};

export default PropertyHeader;
